<script lang="ts">
  import { createEventDispatcher, getContext, onMount } from 'svelte';
  import './css/timeout.scss';
  import { deserialize } from '$app/forms';

  const dispatch = createEventDispatcher();

  const hash = getContext<string>('hash');
  const isEditable = getContext<boolean>('isEditable') || false;

  let visible = false;
  export let phone = '';
  export let leadId = null;
  let codeSent = false;
  let invalidMessage = false;
  $: waitingForNextRequest = 0;

  async function getSMSVerification() {
    if (waitingForNextRequest > 0) {
      return;
    }

    const formData = new FormData();
    formData.append('phone', phone);
    const res = await fetch('/?/verifyPhoneNumber', {
      method: 'POST',
      body: formData,
    });
    const { data } = deserialize(await res.text());

    if (data.sent) {
      visible = true;
      codeSent = true;
      handleTimeout();
    }
  }

  async function sendSMSVerification(event: Event) {
    event.preventDefault();

    const formData = new FormData(event.target as HTMLFormElement);
    formData.append('leadId', leadId as string);

    const res = await fetch('/?/sendVerificationCode', {
      method: 'POST',
      body: formData,
    });
    const { data } = deserialize(await res.text());

    if (!data.valid) {
      return (invalidMessage = true);
    }

    return (visible = false);
  }

  function handleTimeout() {
    if (waitingForNextRequest == 0) {
      waitingForNextRequest = 30;
    }
    if (waitingForNextRequest > 0) {
      waitingForNextRequest--;
      setTimeout(handleTimeout, 1000);
    }
    console.log(waitingForNextRequest);
  }

  onMount(() => {
    getSMSVerification();
  });
</script>

{#if codeSent && visible}
  <section class="timeout-popup show-timeout-popup">
    <div class="blur" />
    <div
      class="timeout-popup-holder !min-h-auto !flex !flex-col !items-center !justify-center"
    >
      <form
        on:submit={sendSMSVerification}
        class="mx-auto flex flex-col items-center justify-center gap-4 px-8 py-12 text-center"
      >
        <h2 class="font-bold">Let’s confirm your number</h2>
        <p class="mx-auto max-w-[500px]">
          To help move your request along faster, enter the code we just texted
          you. It only takes a second.
        </p>
        <input type="hidden" name="phoneNumber" value={phone} />
        <input
          on:input={() => (invalidMessage = false)}
          type="text"
          name="code"
          class="w-full max-w-[300px] rounded-md border border-gray-300 p-4 text-center text-lg"
          placeholder="Enter 6-digit code"
        />
        {#if invalidMessage}
          <p class="text-red-500">
            Hmm, that code doesn’t look right. Please check and try again.
          </p>
        {/if}
        <button
          type="submit"
          class="w-full max-w-[300px] rounded-md bg-[var(--color-accent)] py-4 text-lg font-bold text-[var(--color-neutral-white)]"
          >Confirm</button
        >
      </form>

      <p>
        Didn’t get the code?
        <button
          on:click={getSMSVerification}
          class="underline"
          class:opacity-50={waitingForNextRequest > 0}
          disabled={waitingForNextRequest > 0}
        >
          {#if waitingForNextRequest > 0}
            Resend it in {waitingForNextRequest} seconds
          {:else}
            Resend it
          {/if}
        </button>
      </p>

      <p>We use this to protect your request and ensure faster service.</p>
    </div>
  </section>
{/if}
